import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { decodeUsableToken } from '@shared/helpers/token-expiry.helper';
import { CommonEnvironmentsService } from '@shared/services/environments.service';

// Gate for the MFA challenge screen. A password-only session (VIT-1346
// `mfa_pending` token) carries no roles and is refused by the API on every
// call but the MFA endpoints, so the screen must sit outside the protected
// shell: neither the role-checking AuthenticatedGuard nor the `user` resolver
// may run in front of it. Any usable token is admitted (a full session may
// re-verify its factor); no token, or an expired one, is sent to log in.
@Injectable({
  providedIn: 'root'
})
export class MfaGuard {
  constructor(
    private readonly _commonEnvironments: CommonEnvironmentsService,
    private readonly _router: Router
  ) {}

  public canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const token = this._commonEnvironments.getToken();
    const payload = token ? decodeUsableToken(token) : null;

    if (payload) {
      return true;
    }

    this._commonEnvironments.cleanStorage();
    this._router.navigate(['/login'], {
      queryParams: {
        returnUrl: state.url
      }
    });

    return false;
  }
}
